export default __webpack_public_path__ + "static/media/spinner.a7dab33f.svg";